<template>
  <div id="app">    
    <router-view/>
    <el-backtop :bottom="20" :right="20" :visibility-height="50" title="回到顶部"></el-backtop>
  </div>
</template>

<script>

export default {
  name: 'App',
  components:{
  },
  created(){
    //this.$store.dispatch('account/checkLogin').then(()=>{})
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-backtop{
  background-color: rgba(255, 255, 255, 0.5);
  color: #014289;
}
</style>



// WEBPACK FOOTER //
// src/App.vue